module.exports = __webpack_public_path__ + "img/french-key.c2269df9.svg";